import { DataTableHeader } from 'vuetify';

export function useBetsGridHeaders() {
    return computed<DataTableHeader[]>(() => [
        {
            title: '',
            key: 'goal',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '0',
            key: 'balance_0',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '1',
            key: 'balance_1',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '2',
            key: 'balance_2',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '3',
            key: 'balance_3',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '4',
            key: 'balance_4',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '5',
            key: 'balance_5',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '6',
            key: 'balance_6',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '7',
            key: 'balance_7',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '8',
            key: 'balance_8',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '9',
            key: 'balance_9',
            align: 'center',
            cellClass: 'br',
            sortable: false,
        },
        {
            title: '10',
            key: 'balance_10',
            align: 'center',
            sortable: false,
        },
    ]);
}
